<template>
    <div
        class="form-thumbnail"
        :class="{ showAdd }"
    >
        <div class="img-wrapper" v-show="showImg">
            <img alt="Form thumbnail" :src="src" @load="imgLoaded = true"/>
        </div>
        <transition :name="showImg ? 'fade' : ''">
            <div class="placeholder-wrapper" v-show="!showImg">
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-element"></div>
                <div class="form-thumbnail-add-icon" v-if="showAdd">
                    <i class="far fa-plus"></i>
                </div>
                <div class="loading" v-if="src"></div>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        name: 'FormThumbnail',
        data() {
            return {
                imgLoaded: false
            };
        },
        props: {
            src: {
                type: String,
                default: '',
            },
            showAdd: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            showImg() {
                return this.src && this.imgLoaded;
            }
        },
        watch: {
            src() {
                this.imgLoaded = false;
            }
        },
    };
</script>
 <style lang="scss" scoped>
    .form-thumbnail {
        height: 180px;
        width: 140px;
        min-width: 140px;
        position: relative;
        overflow: hidden;

        &.showAdd {
            overflow: visible;
        }

        .img-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .placeholder-wrapper {
            height: 100%;
            width: 100%;
            border: 1px solid $color-border;
            position: absolute;
            top: 0;
            left: 0;
            background-color: $color-white;
            border-radius: 2px;

            .loading {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                opacity: 0.5;
                z-index: 1;
                animation-duration: 1.5s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: rtlOverlay;
                animation-timing-function: cubic-bezier(0.55, 0.09, 0.68, 0.53);
                background: linear-gradient(
                    to right,
                    transparent 8%,
                    #fff 18%,
                    transparent 32%
                );
                background-size: 800%;
            }
        }

        @keyframes rtlOverlay {
            0% {
                background-position: -468px 0;
            }
            100% {
                background-position: 468px 0;
            }
        }

        img {
            max-height: 100%;
            max-width: 100%;
            border: 1px solid $color-border;
            image-rendering: -moz-crisp-edges; /* Firefox */
            image-rendering: -o-crisp-edges; /* Opera */
            image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
            image-rendering: crisp-edges;
            -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
            border-radius: 2px;
        }

        .form-thumbnail-element {
            position: absolute;
            background-color: $color-border;
            opacity: 0.8;
            border-radius: 5px;

            &:nth-child(1) {
                top: 15px;
                left: 15px;
                width: 30px;
                height: 30px;
            }

            &:nth-child(2) {
                top: 55px;
                left: 15px;
                width: 110px;
                height: 20px;
            }

            &:nth-child(3) {
                top: 85px;
                left: 15px;
                width: 110px;
                height: 20px;
            }

            &:nth-child(4) {
                top: 115px;
                left: 15px;
                width: 55px;
                height: 20px;
            }

            &:nth-child(5) {
                top: 145px;
                left: 15px;
                width: 55px;
                height: 20px;
            }

            &:nth-child(6) {
                top: 115px;
                right: 15px;
                width: 45px;
                height: 50px;
            }
        }

        .form-thumbnail-add-icon {
            position: absolute;
            right: -10px;
            top: -10px;
            background-color: #fff;
            border: 2px solid $color-border;
            opacity: 1;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            color: darken($color-border, 25);
            transition: all 0.3s;
        }
    }
</style>
